import { useMemo } from 'react';
import { useForm } from '../context';

export function useHeaderPricing() {
  const { getTotal, items, isRecurrence, firstItem, installments } = useForm();

  return useMemo(() => {
    const hasOrderBump = !!items.find((item) => item.type === 'order_bump');
    const totalValue = (isRecurrence ? firstItem.amount * firstItem.quantity : getTotal()) / 100;
    const maxInstallment = installments?.[installments?.length - 1]?.installment ?? 0;
    const installmentValue = installments?.[installments?.length - 1]?.value ?? 0;

    const hasEnrollmentFee = items.some((item) => item.type === 'enrollment_fee');
    const validItems = items.filter(
      (item) => !hasEnrollmentFee || ['enrollment_fee', 'order_bump'].includes(item.type)
    );

    const totalDiscountAmount =
      validItems.reduce((acc, item) => {
        if (item.couponItem) {
          return acc + (item.amount - item.couponItem.amount) * item.quantity;
        }
        return acc;
      }, 0) / 100;

    const enrollmentFee = items.find((item) => item.type === 'enrollment_fee');

    return {
      hasOrderBump,
      totalValue,
      maxInstallment,
      installmentValue,
      hasEnrollmentFee,
      totalDiscountAmount,
      enrollmentFee,
      getTotal,
      firstItem,
      isRecurrence,
    };
  }, [items, firstItem, isRecurrence, installments, getTotal]);
}
